// PATH: src/api/auth.ts — authentification via tc_identity (pattern tc_tilmicode_ui) :
// POST /login en Basic auth → tc_identity pose le cookie httpOnly tc_session
// (Domain=.tilmicode.com) ; toutes les requêtes suivantes le portent (withCredentials).
import { useMemo } from "react";
import { useApiClient } from "./apiClients";

export interface CoreUser {
  id: string | number;
  name?: string | null;
  email?: string | null;
  [k: string]: any;
}

export const useAuthApi = () => {
  const api = useApiClient("identity");

  return useMemo(
    () => ({
      loginBasic: async (username: string, password: string): Promise<boolean> => {
        await api.post("/login", null, { auth: { username, password } });
        try {
          await api.get<CoreUser>("/me"); // sanity check session
          return true;
        } catch {
          return false;
        }
      },
      logout: async (): Promise<void> => {
        try {
          await api.post("/logout");
        } catch {
          /* no-op */
        }
      },
      me: async (): Promise<CoreUser> => {
        const { data } = await api.get<CoreUser>("/me");
        return data;
      },
    }),
    [api]
  );
};
